import { PromotionsType, TimeSlotsType } from '@features/tables/schemas/TablesAvailability.schema';

export type DiningMenuOption = {
  value: string;
  label: string;
};

export type DiningMenuSelection = {
  id: string | null;
  name: string | null;
  timeslotReservationId: string | null;
};

export const NO_MENU: DiningMenuSelection = { id: null, name: null, timeslotReservationId: null };

export function getDiningMenuOptions(
  promotions: PromotionsType,
  menuIds: (string | number)[] = []
): DiningMenuOption[] {
  const allowed = menuIds.map(String);

  return promotions
    .filter(({ id }) => !allowed.length || allowed.includes(String(id)))
    .map(({ id, name }) => ({ value: String(id), label: name }));
}

export function filterTimeslotsByMenu(
  timeSlots: TimeSlotsType,
  menuId?: string | null
): TimeSlotsType {
  if (!menuId) {
    return timeSlots;
  }

  return timeSlots.filter((timeSlot) =>
    timeSlot.availablePromotions?.some(({ id }) => String(id) === menuId)
  );
}

export function getMenuSelectionForTimeslot(
  timeSlot: TimeSlotsType[number] | undefined,
  menuId: string | null | undefined,
  menuOptions: DiningMenuOption[]
): DiningMenuSelection {
  if (!menuId) {
    return NO_MENU;
  }

  const availablePromotion = timeSlot?.availablePromotions?.find(({ id }) => String(id) === menuId);

  return {
    id: menuId,
    name: menuOptions.find(({ value }) => value === menuId)?.label ?? null,
    timeslotReservationId: availablePromotion?.timeslotReservationId ?? null,
  };
}

export function getLeaveTimeForSelection(
  timeSlot: TimeSlotsType[number] | undefined,
  menuId?: string | null
): string | null {
  if (!timeSlot?.isLeaveTimeRequired) {
    return null;
  }

  const promotion = menuId
    ? timeSlot.availablePromotions?.find(({ id }) => String(id) === menuId)
    : undefined;

  return promotion?.leaveTime ?? timeSlot.leaveTime ?? null;
}

export function isMenuRequired(
  timeSlot: TimeSlotsType[number] | undefined,
  menuOptions: DiningMenuOption[],
  hasMenuRestriction = false
): boolean {
  if (!menuOptions.length) {
    return false;
  }

  if (hasMenuRestriction) {
    return true;
  }

  return !!timeSlot && !timeSlot.hasStandardAvailability;
}

export function resolveMenuSelection(
  timeSlot: TimeSlotsType[number],
  menuId: string | null | undefined,
  menuOptions: DiningMenuOption[],
  hasMenuRestriction = false
): DiningMenuSelection | undefined {
  if (menuId) {
    return getMenuSelectionForTimeslot(timeSlot, menuId, menuOptions);
  }

  return isMenuRequired(timeSlot, menuOptions, hasMenuRestriction) ? undefined : NO_MENU;
}
